import React, { useEffect, useState } from "react";
import "./FormFieldsStyle.css";

const InputFieldA14input = (props) => {
  const [isSpecialError, setIsSpecialError] = useState("");
  const [isLimitError, setIsLimitlError] = useState("");

  let letter = props?.item?.data ? JSON.parse(props?.item?.data) : null

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return regex.test(email);
  };

  const handleChange = (e) => {
    let value = e?.target?.value.trimStart();

    if (value.startsWith(" ")) {
      return;
    }

    // if (value.length >= 50 && props?.item?.text !== "rem") {
    //   props?.inputValue?.current?.setAttribute("disabled", true);
    //   setIsLimitlError("Maximum character value is 50");
    //   return;
    // }
    if (letter?.limit && value.length > letter.limit) {
        setIsLimitlError(`Maximum character limit is ${letter.limit}`);
         props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { inputError: "Special characters" },
          }));
        return;
    } else if (!letter?.limit && value.length >= 200) {
        setIsLimitlError(`Maximum character limit is 200`);
        return
    }

    if (value.length > 0) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    //  EMAIL VALIDATION
    if (props?.item?.text === "email") {
      if (
        !/^[a-zA-Z0-9\s@.,]*$/.test(value) ||
        value.startsWith(".") ||
        value.startsWith(",")
      ) {
        props?.inputValue?.current?.setAttribute("disabled", true);
        setIsSpecialError("No Special characters are allowed");
        setIsLimitlError("");
      } else {
        setIsSpecialError("");
        setIsLimitlError("");
        localStorage.setItem("inputValue", JSON.stringify({ key1: e.target.value }));
      }

      if (isValidEmail(e.target.value)) {
        props?.setErrors((prevErrors) => ({
          ...prevErrors,
          [props?.index]: { key1: e.target.value, displayName: e.target.value },
        }));
      } else {
        props?.setErrors((prevErrors) => ({
          ...prevErrors,
          [props?.index]: { inputError: "email" },
        }));
      }

    // ✅ REM VALIDATION (only numbers, 10-digit limit, shouldn't start with 0)
    } else if (props?.item?.text === "rmn") {
      if (!/^[1-9][0-9]{0,9}$/.test(value)) {
        props?.inputValue?.current?.setAttribute("disabled", true);
        setIsLimitlError("");
        if (!/^[0-9]*$/.test(value)) {
          setIsSpecialError("Only numbers are allowed");
          props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { inputError: "Special characters" },
          }));
        } else if (value.startsWith("0")) {
          setIsSpecialError("Shouldn't start with 0");
          props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { inputError: "Special characters" },
          }));
        } else if (value.length > 10) {
          setIsLimitlError("Only 10 digits allowed");
          props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { inputError: "Special characters" },
          }));
        } else {
          setIsSpecialError("Invalid input");
          props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { inputError: "Special characters" },
          }));
        }
        return;
      } else {
        setIsSpecialError("");
        setIsLimitlError("");
        props?.inputValue?.current?.removeAttribute("disabled");
        props?.setErrors((prevErrors) => ({
          ...prevErrors,
          [props?.index]: { key1: e.target.value, displayName: e.target.value },
        }));
        localStorage.setItem("inputValue", JSON.stringify({ key1: e.target.value }));
      }

    //  DEFAULT CASE
    } else {
      setIsSpecialError("");
      setIsLimitlError("");
      props?.setErrors((prevErrors) => ({
        ...prevErrors,
        [props?.index]: { key1: e.target.value, displayName: e.target.value },
      }));
      localStorage.setItem("inputValue", JSON.stringify({ key1: e.target.value }));
    }
  };

  return (
    <>
      <div className="form-group">
        <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
          {/* {props.item.text} */}
          <span className="asterisk-icon"></span>
        </label>
        <input
          type="text"
          className={`form-control error-${props?.index}`}
          placeholder={props?.item?.infoText || "Enter"}
          disabled={props.disable}
          defaultValue={(props.userInputObj && props.userInputObj.key1) || ""}
          onInput={(e) => handleChange(e)}
          style={{ marginLeft: "6px", width: "90%" }}
        />
        <span className="validate">&nbsp;</span>
        <div
          style={{
            color: "red",
            marginBottom: "12px",
            fontSize: 12,
            marginLeft: "10px",
          }}
        >
          {isSpecialError && isSpecialError}
          {isLimitError && isLimitError}
        </div>
      </div>
    </>
  );
};

export default InputFieldA14input;
